(function () {
  'use strict';

  const CELL = 20, DURATION = 60, ENERGY_MAX = 100, AUTO_SPEED = 8;
  const BRAND = { lime: '#d7ff00', darkGreen: '#094812', yellow: '#ffd600', white: '#fff' };
  const GRASS = ['#a8d5a2', '#5cb85c', '#3a9a3a', '#24712b'];
  const OBSTACLES = [
    { id: 'rock', emoji: '🪨' }, { id: 'gnome', emoji: '🧌' },
    { id: 'toy', emoji: '🧸' }, { id: 'cone', emoji: '🔺' },
  ];
  const EVENTS = [
    { id: 'phone',    text: '📱  Your wife is calling!',                dur: 3.0 },
    { id: 'doorbell', text: '🔔  Doorbell! Expecting a package?',      dur: 2.5 },
    { id: 'neighbor', text: '🏠  Neighbor: "Your lawn looks terrible!"', dur: 2.5 },
    { id: 'hoa',      text: '📋  HOA WARNING: Lawn height violation!',  dur: 3.0 },
    { id: 'dog',      text: '🐕  A dog just ran into your yard!',       dur: 2.0 },
    { id: 'kid',      text: '🧒  Kids threw toys on the lawn!',         dur: 2.0 },
    { id: 'bee',      text: '🐝  Bees! Run!',                           dur: 2.0 },
  ];
  const ACHS = [
    { id: 'first',   name: 'First Blood',      desc: 'Mow your first cell', test: s => s.cellsMowed >= 1 },
    { id: 'combo5',  name: 'Combo King',        desc: '5x combo!',           test: s => s.combo >= 5 },
    { id: 'combo10', name: 'Unstoppable',       desc: '10x combo!',          test: s => s.combo >= 10 },
    { id: 'hit5',    name: 'Stone Cold',        desc: 'Hit 5 obstacles',     test: s => s.hits >= 5 },
    { id: 'rage',    name: 'Rage Quit',         desc: 'Give up in 30s',      test: s => s.rageQuit },
    { id: 'low',     name: 'Running on Empty',  desc: 'Energy below 5%',     test: s => s.energy <= 5 },
    { id: 'rain',    name: 'Soggy Mower',       desc: 'Mow in the rain',     test: s => s.mowedInRain },
    { id: 'pro',     name: 'The Machine',       desc: '80%+ coverage',       test: s => s.coverage >= 80 },
    { id: 'lemon',   name: 'Lemonade Life',     desc: 'Watch LOPKIN mow',    test: s => s.watchedAuto },
  ];

  class Sfx {
    constructor() { this.ctx = null; }
    init() { if (!this.ctx) try { this.ctx = new (window.AudioContext || window.webkitAudioContext)(); } catch (_) {} }
    _t(f, d, type, v) {
      if (!this.ctx) return;
      const o = this.ctx.createOscillator(), g = this.ctx.createGain();
      o.type = type; o.frequency.value = f;
      g.gain.setValueAtTime(v, this.ctx.currentTime);
      g.gain.exponentialRampToValueAtTime(0.001, this.ctx.currentTime + d);
      o.connect(g).connect(this.ctx.destination); o.start(); o.stop(this.ctx.currentTime + d);
    }
    mow()   { this._t(220 + Math.random() * 60, 0.06, 'sawtooth', 0.05); }
    hit()   { this._t(100, 0.2, 'square', 0.12); }
    combo() { this._t(520, 0.12, 'sine', 0.07); }
    alert() { this._t(800, 0.15, 'square', 0.1); setTimeout(() => this._t(600, 0.15, 'square', 0.1), 180); }
    victory() { [0,150,300,450].forEach((d, i) => setTimeout(() => this._t(523 + i * 80, 0.25, 'sine', 0.09), d)); }
    engine() { this._t(90 + Math.random() * 20, 0.1, 'sawtooth', 0.03); }
  }

  class MowerGame {
    constructor(id) {
      this.canvas = document.getElementById(id);
      if (!this.canvas) return;
      this.ctx = this.canvas.getContext('2d');
      this.sfx = new Sfx();
      this.dpr = Math.min(window.devicePixelRatio || 1, 2);
      this.W = 800; this.H = 380; this.HUD = 36;
      this.cols = Math.floor(this.W / CELL);
      this.rows = Math.floor(this.H / CELL);
      this.resize();

      this.state = 'menu'; this.st = 0;
      this.grid = []; this.obs = []; this.particles = [];
      this.dog = null; this.achDone = new Set(); this.achPops = [];
      this.p = this._fp();
      this.lk = {}; this.weather = {}; this.tm = {};
      this.evt = null; this.evtQ = []; this.evtI = 0;
      this.autoGrid = []; this.autoT = 0;
      this.shk = { x: 0, y: 0 }; this.result = null;
      this.keys = {}; this.moveCD = 0;

      this._bind();
      this._ts = 0;
      requestAnimationFrame(t => this._loop(t));
    }

    _fp() {
      return {
        col: 2, row: 2, dir: 'right', energy: ENERGY_MAX,
        combo: 0, maxCombo: 0, score: 0, hits: 0, cellsMowed: 0,
        mowedInRain: false, rageQuit: false, coverage: 0,
        watchedAuto: false, fuelEmpty: false, fuelTaps: 0, fuelForced: false,
      };
    }

    resize() {
      const totalH = this.H + this.HUD;
      const w = Math.min(this.W, this.canvas.parentElement.clientWidth);
      this.canvas.width = this.W * this.dpr; this.canvas.height = totalH * this.dpr;
      this.canvas.style.width = w + 'px'; this.canvas.style.height = (w / this.W * totalH) + 'px';
      this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    }

    _initGrid() {
      this.grid = [];
      for (let r = 0; r < this.rows; r++) { this.grid[r] = []; for (let c = 0; c < this.cols; c++) this.grid[r][c] = 2; }
    }

    _placeObs(n) {
      this.obs = [];
      for (let i = 0; i < n; i++) {
        let t = 0, c, r;
        do { c = 2 + (Math.random() * (this.cols - 4) | 0); r = 2 + (Math.random() * (this.rows - 4) | 0); t++; }
        while (t < 50 && this.obs.some(o => Math.abs(o.c - c) < 2 && Math.abs(o.r - r) < 2));
        this.obs.push({ c, r, ...OBSTACLES[Math.random() * OBSTACLES.length | 0] });
      }
    }

    _shuffle(arr) {
      const a = [...arr];
      for (let i = a.length - 1; i > 0; i--) { const j = Math.random() * (i + 1) | 0; [a[i], a[j]] = [a[j], a[i]]; }
      return a;
    }

    /* ── input ── */
    _bind() {
      const pv = e => { if (['ArrowUp','ArrowDown','ArrowLeft','ArrowRight',' '].includes(e.key)) e.preventDefault(); };
      document.addEventListener('keydown', e => { pv(e); this.keys[e.key] = true; this._onKey(e.key); });
      document.addEventListener('keyup', e => { pv(e); this.keys[e.key] = false; });
      this.canvas.addEventListener('click', () => { this.sfx.init(); this._onKey(' '); });
      document.querySelectorAll('.ctrl-btn').forEach(b => {
        const d = b.dataset.dir;
        const map = { up: 'ArrowUp', down: 'ArrowDown', left: 'ArrowLeft', right: 'ArrowRight' };
        const on = () => { this.sfx.init(); this.keys[map[d]] = true; };
        const off = () => { this.keys[map[d]] = false; };
        b.addEventListener('touchstart', e => { e.preventDefault(); on(); }, { passive: false });
        b.addEventListener('touchend', e => { e.preventDefault(); off(); }, { passive: false });
        b.addEventListener('mousedown', on); b.addEventListener('mouseup', off); b.addEventListener('mouseleave', off);
      });
      const rp = document.getElementById('btn-replay');
      if (rp) rp.addEventListener('click', () => { this.state = 'menu'; this.st = 0; });
      const autoBtn = document.getElementById('btn-auto-mow');
      if (autoBtn) autoBtn.addEventListener('click', () => { if (this.state === 'playing') this._endManual(); });
      window.addEventListener('resize', () => this.resize());
    }

    _onKey(k) {
      this.sfx.init();
      if (k === ' ') {
        if (this.state === 'menu') this._start();
        else if (this.state === 'playing' && this.evt) this.evt = null;
        else if (this.state === 'playing' && this.p.fuelEmpty) {
          this.p.fuelTaps++;
          if (this.p.fuelTaps >= 8) { this.p.fuelEmpty = false; this.p.energy = ENERGY_MAX; }
        }
      }
      if (k === 'Escape' && this.state === 'playing') {
        if (this.tm.elapsed < 30) this.p.rageQuit = true;
        this._endManual();
      }
    }

    _getDir() {
      const k = this.keys;
      if (k.ArrowUp || k.w || k.W) return [0, -1];
      if (k.ArrowDown || k.s || k.S) return [0, 1];
      if (k.ArrowLeft || k.a || k.A) return [-1, 0];
      if (k.ArrowRight || k.d || k.D) return [1, 0];
      return null;
    }

    _stepPlayer(dc, dr) {
      const p = this.p;
      const nc = p.col + dc, nr = p.row + dr;
      if (nc < 0 || nc >= this.cols || nr < 0 || nr >= this.rows) return;

      if (dc > 0) p.dir = 'right'; else if (dc < 0) p.dir = 'left';
      else if (dr > 0) p.dir = 'down'; else p.dir = 'up';

      for (const ob of this.obs) {
        if (ob.c === nc && ob.r === nr) {
          p.hits++; p.combo = 0; this.sfx.hit();
          this.shk.x = (Math.random() - .5) * 8; this.shk.y = (Math.random() - .5) * 8;
          this._sparks(ob.c * CELL + CELL / 2, ob.r * CELL + CELL / 2, '#aaa', 6);
          return;
        }
      }

      if (this.dog) {
        const dogC = this.dog.x / CELL | 0, dogR = this.dog.y / CELL | 0;
        if (nc === dogC && nr === dogR) { p.combo = 0; return; }
      }

      p.col = nc; p.row = nr;
      this._mow(nc, nr);
      this.sfx.engine();

      const drain = this.weather.rain ? 3 : 2;
      p.energy = Math.max(0, p.energy - drain);
      if (p.energy <= 0) { p.fuelEmpty = true; p.fuelTaps = 0; }
    }

    _start() {
      this._initGrid();
      this._placeObs(8 + (Math.random() * 5 | 0));
      this.p = this._fp();
      this.weather = { rain: false, drops: [], at: 28 + Math.random() * 10 };
      this.tm = { elapsed: 0, remain: DURATION, nextEvt: 5 + Math.random() * 3 };
      this.evt = null; this.evtQ = this._shuffle(EVENTS); this.evtI = 0;
      this.dog = null; this.particles = [];
      this.shk = { x: 0, y: 0 }; this.state = 'countdown'; this.st = 0;
      document.getElementById('game-cta').style.display = 'none';
      const ab = document.getElementById('game-auto-btn');
      if (ab) ab.style.display = 'block';
    }

    /* ── loop ── */
    _loop(ts) {
      const dt = Math.min((ts - this._ts) / 1000, 0.05); this._ts = ts; this.st += dt;
      this._update(dt); this._draw();
      requestAnimationFrame(t => this._loop(t));
    }

    _update(dt) {
      this.particles = this.particles.filter(p => { p.x += p.vx * dt; p.y += p.vy * dt; p.vy += 120 * dt; p.l -= dt; return p.l > 0; });
      (this.achPops || []).forEach(a => a.t += dt);
      this.achPops = (this.achPops || []).filter(a => a.t < 3);
      this.shk.x *= 0.85; this.shk.y *= 0.85;
      if (this.state === 'countdown' && this.st >= 3) { this.state = 'playing'; this.st = 0; }
      else if (this.state === 'playing') this._play(dt);
      else if (this.state === 'transition') this._trans(dt);
      else if (this.state === 'auto') this._auto(dt);
    }

    _play(dt) {
      this.tm.elapsed += dt;
      this.tm.remain = Math.max(0, DURATION - this.tm.elapsed);
      if (this.tm.remain <= 0) { this._endManual(); return; }

      if (!this.weather.rain && this.tm.elapsed >= this.weather.at) this.weather.rain = true;
      if (this.weather.rain && Math.random() < 0.4)
        this.weather.drops.push({ x: Math.random() * this.W, y: -5, sp: 250 + Math.random() * 150, ln: 8 + Math.random() * 8 });
      this.weather.drops = this.weather.drops.filter(d => { d.y += d.sp * dt; return d.y < this.H; });

      if (this.tm.elapsed > 55 && !this.p.fuelEmpty && !this.p.fuelForced && this.p.energy > 20) {
        this.p.energy = 0; this.p.fuelEmpty = true; this.p.fuelTaps = 0; this.p.fuelForced = true;
      }

      this.tm.nextEvt -= dt;
      if (this.tm.nextEvt <= 0 && !this.evt) {
        const ev = this.evtQ[this.evtI++ % this.evtQ.length];
        this.evt = { ...ev, timer: ev.dur }; this.sfx.alert();
        if (ev.id === 'dog' && !this.dog) this.dog = { x: Math.random() * this.W, y: 0, t: 0 };
        if (ev.id === 'kid') for (let i = 0; i < 2; i++)
          this.obs.push({ c: 2 + (Math.random() * (this.cols - 4) | 0), r: 2 + (Math.random() * (this.rows - 4) | 0), id: 'toy', emoji: '🧸' });
        this.tm.nextEvt = 8 + Math.random() * 7;
      }
      if (this.evt) { this.evt.timer -= dt; if (this.evt.timer <= 0) this.evt = null; }

      if (this.dog) {
        this.dog.t += dt;
        const px = this.p.col * CELL + CELL / 2, py = this.p.row * CELL + CELL / 2;
        const dx = px - this.dog.x, dy = py - this.dog.y, d = Math.sqrt(dx * dx + dy * dy);
        if (d > 5) { this.dog.x += dx / d * 50 * dt; this.dog.y += dy / d * 50 * dt; }
        if (this.dog.t > 15) this.dog = null;
      }

      this.moveCD = Math.max(0, this.moveCD - dt);
      if (!this.p.fuelEmpty && !this.evt && this.moveCD <= 0) {
        const dir = this._getDir();
        if (dir) { this._stepPlayer(dir[0], dir[1]); this.moveCD = 0.15; }
      }

      this._ach();
    }

    _mow(c, r) {
      if (r < 0 || r >= this.rows || c < 0 || c >= this.cols || this.grid[r][c] === 0) return;
      this.grid[r][c] = 0; this.p.cellsMowed++;
      this.p.combo = Math.min(15, this.p.combo + 1);
      if (this.p.combo > this.p.maxCombo) this.p.maxCombo = this.p.combo;
      this.p.score += 10 * Math.min(5, 1 + (this.p.combo / 3 | 0));
      this.sfx.mow();
      if (this.p.combo % 3 === 0 && this.p.combo >= 3) this.sfx.combo();
      if (this.weather.rain) this.p.mowedInRain = true;
      this._sparks(c * CELL + CELL / 2, r * CELL + CELL / 2, GRASS[1 + (Math.random() * 2 | 0)], 3);
    }

    _sparks(x, y, color, n) {
      for (let i = 0; i < n; i++)
        this.particles.push({ x, y, color, vx: (Math.random()-.5)*100, vy: -30-Math.random()*60, l: 0.4+Math.random()*0.3, ml: 0.7, sz: 2+Math.random()*2 });
    }

    _endManual() {
      const total = this.rows * this.cols;
      let m = 0;
      for (let r = 0; r < this.rows; r++) for (let c = 0; c < this.cols; c++) if (this.grid[r][c] === 0) m++;
      this.p.coverage = Math.round(m / total * 100);
      this._ach();

      this.obsSet = new Set();
      for (const ob of this.obs) this.obsSet.add(ob.r + ',' + ob.c);

      this.autoGrid = [];
      for (let r = 0; r < this.rows; r++) { this.autoGrid[r] = []; for (let c = 0; c < this.cols; c++) this.autoGrid[r][c] = 2; }

      this.autoPath = this._buildAutoPath();
      this.lk = { pi: 0, col: this.autoPath[0].c, row: this.autoPath[0].r, done: false, mowed: 0,
                  px: this.autoPath[0].c * CELL, py: this.autoPath[0].r * CELL };
      this.autoT = 0; this.weather.drops = [];
      this.state = 'transition'; this.st = 0;
      const ab = document.getElementById('game-auto-btn');
      if (ab) ab.style.display = 'none';
    }

    _buildAutoPath() {
      const obsSet = new Set();
      for (const ob of this.obs) obsSet.add(ob.r + ',' + ob.c);
      const path = [];

      for (let row = 0; row < this.rows; row++) {
        const goRight = row % 2 === 0;
        const start = goRight ? 0 : this.cols - 1;
        const end = goRight ? this.cols : -1;
        const step = goRight ? 1 : -1;
        const skip = new Set();

        for (let c = start; c !== end; c += step) {
          if (skip.has(c)) continue;

          if (obsSet.has(row + ',' + c)) {
            const below = row + 1;
            const prev = c - step;
            const past = c + step;
            if (below < this.rows && prev >= 0 && prev < this.cols && past >= 0 && past < this.cols
                && !obsSet.has(below + ',' + prev) && !obsSet.has(below + ',' + c) && !obsSet.has(below + ',' + past)) {
              path.push({ c: prev, r: below });
              path.push({ c, r: below });
              path.push({ c: past, r: below });
              path.push({ c: past, r: row });
              skip.add(past);
            }
          } else {
            path.push({ c, r: row });
          }
        }
      }

      const mowed = new Set();
      for (const wp of path) mowed.add(wp.r + ',' + wp.c);
      for (let r = 0; r < this.rows; r++) for (let c = 0; c < this.cols; c++) {
        const key = r + ',' + c;
        if (!mowed.has(key) && !obsSet.has(key)) path.push({ c, r });
      }

      return path;
    }

    _trans(dt) {
      if (this.st >= 6) { this.state = 'auto'; this.st = 0; this.p.watchedAuto = true; }
    }

    /* ── AUTO: grid-based movement, mow only current cell ── */
    _auto(dt) {
      this.autoT += dt;
      const lk = this.lk;
      if (lk.done) { if (this.st > 2) this._results(); return; }

      if (lk.pi >= this.autoPath.length) { lk.done = true; this.sfx.victory(); this.st = 0; return; }

      const target = this.autoPath[lk.pi];
      const tx = target.c * CELL, ty = target.r * CELL;
      const dx = tx - lk.px, dy = ty - lk.py;
      const dist = Math.sqrt(dx * dx + dy * dy);
      const speed = AUTO_SPEED * 60 * dt;

      if (dist < speed) {
        lk.px = tx; lk.py = ty; lk.col = target.c; lk.row = target.r;
        if (this.autoGrid[lk.row][lk.col] > 0 && !this.obsSet.has(lk.row + ',' + lk.col)) {
          this.autoGrid[lk.row][lk.col] = 0; lk.mowed++;
          this.particles.push({ x: lk.px + CELL / 2, y: lk.py + CELL / 2, color: BRAND.lime, vx: (Math.random() - .5) * 40, vy: -20 - Math.random() * 30, l: 0.3, ml: 0.3, sz: 2 });
        }
        lk.pi++;
      } else {
        lk.px += dx / dist * speed;
        lk.py += dy / dist * speed;
      }
    }

    _results() {
      let total = 0, am = 0;
      for (let r = 0; r < this.rows; r++) for (let c = 0; c < this.cols; c++) {
        if (this.obsSet.has(r + ',' + c)) continue;
        total++;
        if (this.autoGrid[r][c] === 0) am++;
      }
      this.result = {
        yt: Math.round(this.tm.elapsed), yc: this.p.coverage, yh: this.p.hits,
        ys: this.p.score, yco: Math.floor(this.p.maxCombo),
        lt: Math.round(this.autoT), lc: Math.round(am / total * 100),
      };
      this._ach(); this.state = 'results'; this.st = 0;
      document.getElementById('game-cta').style.display = 'block';
      this.canvas.parentElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    _ach() {
      for (const a of ACHS) {
        if (this.achDone.has(a.id) || !a.test(this.p)) continue;
        this.achDone.add(a.id);
        this.achPops.push({ name: a.name, desc: a.desc, t: 0 });
      }
    }

    _cov(grid) {
      let m = 0, total = this.rows * this.cols;
      for (let r = 0; r < this.rows; r++) for (let c = 0; c < this.cols; c++) if (grid[r][c] === 0) m++;
      return Math.round(m / total * 100);
    }

    /* ═══════════ DRAW ═══════════ */
    _draw() {
      const c = this.ctx; c.save(); c.translate(this.shk.x, this.shk.y);
      const fn = { menu: '_dMenu', countdown: '_dCount', playing: '_dPlay', transition: '_dTrans', auto: '_dAuto', results: '_dRes' };
      if (fn[this.state]) this[fn[this.state]](c);
      this._dAchPops(c);
      c.restore();
    }

    _rr(c, x, y, w, h, r) {
      c.beginPath(); c.moveTo(x+r, y);
      c.lineTo(x+w-r, y); c.quadraticCurveTo(x+w, y, x+w, y+r);
      c.lineTo(x+w, y+h-r); c.quadraticCurveTo(x+w, y+h, x+w-r, y+h);
      c.lineTo(x+r, y+h); c.quadraticCurveTo(x, y+h, x, y+h-r);
      c.lineTo(x, y+r); c.quadraticCurveTo(x, y, x+r, y); c.closePath();
    }

    _dGrass(c, g) {
      for (let r = 0; r < this.rows; r++) for (let co = 0; co < this.cols; co++) {
        c.fillStyle = GRASS[g[r][co]]; c.fillRect(co*CELL, r*CELL, CELL, CELL);
      }
    }

    _dObs(c, obs) {
      for (const o of obs) {
        const x = o.c * CELL, y = o.r * CELL;
        c.fillStyle = 'rgba(120,60,20,0.85)';
        c.fillRect(x + 1, y + 1, CELL - 2, CELL - 2);
        c.strokeStyle = 'rgba(255,255,255,0.7)'; c.lineWidth = 1.5;
        c.strokeRect(x + 1, y + 1, CELL - 2, CELL - 2);
        c.font = '14px sans-serif'; c.textAlign = 'center'; c.textBaseline = 'middle';
        c.fillText(o.emoji, x + CELL / 2, y + CELL / 2 + 1);
      }
    }

    _dMower(c, x, y, isLk) {
      if (isLk) {
        c.fillStyle = '#888'; c.fillRect(x + 1, y + 1, CELL - 2, CELL - 2);
        c.fillStyle = '#aaa'; c.fillRect(x + 3, y + 3, CELL - 6, CELL - 6);
        c.fillStyle = '#fff'; c.font = 'bold 8px sans-serif'; c.textAlign = 'center'; c.textBaseline = 'middle';
        c.fillText('L', x + CELL / 2, y + CELL / 2 + 1);
      } else {
        c.fillStyle = '#e74c3c'; c.fillRect(x + 1, y + 1, CELL - 2, CELL - 2);
        c.fillStyle = '#c0392b'; c.fillRect(x + 3, y + 3, CELL - 6, CELL - 6);
        c.fillStyle = '#fff'; c.font = 'bold 8px sans-serif'; c.textAlign = 'center'; c.textBaseline = 'middle';
        c.fillText('M', x + CELL / 2, y + CELL / 2 + 1);
      }
    }

    _dPart(c) {
      for (const p of this.particles) {
        c.globalAlpha = Math.max(0, p.l / p.ml);
        c.fillStyle = p.color; c.fillRect(p.x, p.y, p.sz, p.sz);
      }
      c.globalAlpha = 1;
    }

    _dWeather(c) {
      if (!this.weather.rain) return;
      c.strokeStyle = 'rgba(180,210,255,0.4)'; c.lineWidth = 1;
      for (const d of this.weather.drops) { c.beginPath(); c.moveTo(d.x, d.y); c.lineTo(d.x-2, d.y+d.ln); c.stroke(); }
      c.fillStyle = 'rgba(0,0,50,0.12)'; c.fillRect(0, 0, this.W, this.H);
    }

    _dAchPops(c) {
      if (!this.achPops) return;
      for (let i = 0; i < this.achPops.length; i++) {
        const a = this.achPops[i]; if (!a || a.t >= 3) continue;
        c.globalAlpha = a.t < 0.3 ? a.t/0.3 : a.t > 2.5 ? 1-(a.t-2.5)/0.5 : 1;
        const y = 60 + i * 50;
        c.fillStyle = 'rgba(0,0,0,0.8)'; this._rr(c, this.W/2-130, y, 260, 40, 8); c.fill();
        c.fillStyle = BRAND.lime; c.font = 'bold 13px sans-serif'; c.textAlign = 'center';
        c.fillText('🏆 ' + a.name, this.W/2, y+17);
        c.fillStyle = '#ccc'; c.font = '11px sans-serif'; c.fillText(a.desc, this.W/2, y+32);
        c.globalAlpha = 1;
      }
    }

    /* ── screens ── */
    _dMenu(c) {
      const th = this.H + this.HUD;
      c.fillStyle = '#1a5c1a'; c.fillRect(0, 0, this.W, th);
      const t = this.st;
      for (let r = 0; r < this.rows; r++) for (let co = 0; co < this.cols; co++) {
        const sw = Math.sin(t*2+co*0.3+r*0.2)*2;
        c.fillStyle = GRASS[2 + (Math.sin(co*0.5+r*0.7) > 0 ? 0 : -1) + 1];
        c.fillRect(co*CELL+sw, r*CELL, CELL-1, CELL-1);
      }
      c.fillStyle = 'rgba(0,0,0,0.55)'; c.fillRect(0, 0, this.W, th);
      c.textAlign = 'center'; c.textBaseline = 'middle';
      c.fillStyle = BRAND.lime; c.font = 'bold 48px sans-serif';
      c.fillText('MOW MASTER', this.W/2, th/2-60);
      c.fillStyle = BRAND.white; c.font = '18px sans-serif';
      c.fillText('The LOPKIN Lawn Challenge', this.W/2, th/2-15);
      c.font = '50px sans-serif'; c.fillText('🚜', this.W/2-15, th/2+40+Math.sin(t*3)*5);
      if (Math.sin(t*4) > 0) { c.fillStyle = BRAND.yellow; c.font = 'bold 16px sans-serif'; c.fillText('Press SPACE or Tap to Start', this.W/2, th/2+110); }
      c.fillStyle = '#aaa'; c.font = '13px sans-serif';
      c.fillText('Use WASD or Arrow Keys to mow  •  ESC to give up', this.W/2, th-20);
    }

    _dCount(c) {
      c.save(); c.translate(0, this.HUD);
      this._dGrass(c, this.grid); this._dObs(c, this.obs);
      c.fillStyle = 'rgba(0,0,0,0.5)'; c.fillRect(0, 0, this.W, this.H);
      const n = 3 - (this.st|0), sc = 1 + (this.st%1)*0.3;
      c.save(); c.translate(this.W/2, this.H/2); c.scale(sc, sc);
      c.globalAlpha = 1 - this.st%1; c.textAlign = 'center'; c.textBaseline = 'middle';
      c.fillStyle = BRAND.lime; c.font = 'bold 120px sans-serif'; c.fillText(n > 0 ? n : 'GO!', 0, 0);
      c.restore();
      c.restore();
    }

    _dPlay(c) {
      this._dHUD(c);
      c.save(); c.translate(0, this.HUD);
      this._dGrass(c, this.grid); this._dObs(c, this.obs);
      if (this.dog) { c.font = '26px sans-serif'; c.textAlign = 'center'; c.textBaseline = 'middle'; c.fillText('🐕', this.dog.x, this.dog.y); }
      this._dMower(c, this.p.col * CELL, this.p.row * CELL, false);
      this._dPart(c); this._dWeather(c);
      c.restore();
      if (this.evt) this._dEvt(c);
      if (this.p.fuelEmpty) this._dFuel(c);
    }

    _dHUD(c) {
      const p = this.p;
      c.fillStyle = 'rgba(0,0,0,0.6)'; c.fillRect(0, 0, this.W, 36);
      c.textAlign = 'left'; c.textBaseline = 'middle'; c.font = 'bold 14px sans-serif';
      c.fillStyle = this.tm.remain < 15 ? '#ff6b6b' : BRAND.white;
      c.fillText('⏱ ' + Math.ceil(this.tm.remain) + 's', 12, 18);
      c.fillStyle = BRAND.yellow; c.fillText('Score: ' + p.score, 100, 18);
      if (p.combo >= 2) {
        c.fillStyle = BRAND.lime; c.font = 'bold ' + Math.round(14*(1+Math.sin(this.st*10)*0.1)) + 'px sans-serif';
        c.fillText('x' + Math.min(5,1+(p.combo/3|0)) + ' COMBO', 220, 18); c.font = 'bold 14px sans-serif';
      }
      c.textAlign = 'right'; c.fillStyle = BRAND.white; c.fillText('Coverage: ' + this._cov(this.grid) + '%', this.W-12, 18);
      c.textAlign = 'left'; c.fillStyle = BRAND.white; c.font = '12px sans-serif'; c.fillText('Energy', 360, 18);
      c.fillStyle = 'rgba(255,255,255,0.2)'; c.fillRect(410, 10, 80, 14);
      c.fillStyle = p.energy > 30 ? '#4caf50' : p.energy > 15 ? '#ff9800' : '#f44336';
      c.fillRect(410, 10, 80*(p.energy/ENERGY_MAX), 14);
      c.textAlign = 'center'; c.font = '16px sans-serif'; c.fillText(this.weather.rain ? '🌧️' : '☀️', this.W/2, 18);
    }

    _dEvt(c) {
      const th = this.H + this.HUD;
      c.fillStyle = 'rgba(0,0,0,0.65)'; c.fillRect(0, 0, this.W, th);
      c.fillStyle = 'rgba(30,30,30,0.95)'; this._rr(c, this.W/2-200, th/2-50, 400, 100, 16); c.fill();
      c.fillStyle = BRAND.white; c.font = 'bold 18px sans-serif'; c.textAlign = 'center'; c.textBaseline = 'middle';
      c.fillText(this.evt.text, this.W/2, th/2-8);
      if (Math.sin(this.st*6) > 0) { c.fillStyle = BRAND.yellow; c.font = '14px sans-serif'; c.fillText('Press SPACE to dismiss', this.W/2, th/2+28); }
    }

    _dFuel(c) {
      const th = this.H + this.HUD;
      c.fillStyle = 'rgba(0,0,0,0.5)'; c.fillRect(0, th/2-60, this.W, 120);
      c.textAlign = 'center'; c.textBaseline = 'middle';
      c.fillStyle = '#ff6b6b'; c.font = 'bold 22px sans-serif'; c.fillText('⛽ OUT OF FUEL!', this.W/2, th/2-20);
      c.fillStyle = BRAND.yellow; c.font = 'bold 16px sans-serif';
      c.fillText('Spam SPACE to pull-start! (' + this.p.fuelTaps + '/8)', this.W/2, th/2+12);
      c.fillStyle = 'rgba(255,255,255,0.2)'; c.fillRect(this.W/2-80, th/2+30, 160, 12);
      c.fillStyle = BRAND.lime; c.fillRect(this.W/2-80, th/2+30, 160*Math.min(this.p.fuelTaps/8, 1), 12);
    }

    _dTrans(c) {
      const th = this.H + this.HUD;
      c.fillStyle = '#111'; c.fillRect(0, 0, this.W, th);
      c.globalAlpha = Math.min(1, this.st); c.textAlign = 'center'; c.textBaseline = 'middle';
      const t = this.st;
      if (t < 2) { c.fillStyle = BRAND.white; c.font = '24px sans-serif'; c.fillText('There has to be a better way...', this.W/2, th/2); }
      else if (t < 4) { c.fillStyle = BRAND.white; c.font = '24px sans-serif'; c.fillText('What if your lawn... mowed itself?', this.W/2, th/2); }
      else {
        c.fillStyle = BRAND.lime; c.font = 'bold 42px sans-serif'; c.fillText('✦  LOPKIN  ✦', this.W/2, th/2);
        c.fillStyle = 'rgba(215,255,0,0.15)';
        c.beginPath(); c.arc(this.W/2, th/2, 70+Math.sin(t*4)*10, 0, Math.PI*2); c.fill();
      }
      c.globalAlpha = 1;
    }

    _dAuto(c) {
      c.fillStyle = 'rgba(9,72,18,0.85)'; c.fillRect(0, 0, this.W, this.HUD);
      c.fillStyle = BRAND.lime; c.font = 'bold 14px sans-serif'; c.textAlign = 'center'; c.textBaseline = 'middle';
      c.fillText('🤖  LOPKIN Auto-Mowing  •  Sit back and relax...', this.W/2, 18);
      c.textAlign = 'right'; c.fillStyle = BRAND.white; c.fillText(this._cov(this.autoGrid) + '%', this.W-12, 18);
      c.save(); c.translate(0, this.HUD);
      this._dGrass(c, this.autoGrid); this._dObs(c, this.obs);
      this._dMower(c, this.lk.px, this.lk.py, true); this._dPart(c);
      c.font = '28px sans-serif'; c.textAlign = 'left'; c.fillText('🧃🛋️', this.W-70, this.H-25);
      c.fillStyle = 'rgba(255,255,255,0.6)'; c.font = '11px sans-serif'; c.fillText('You, relaxing', this.W-100, this.H-50);
      c.restore();
    }

    _dRes(c) {
      const d = this.result; if (!d) return;
      const th = this.H + this.HUD;
      c.fillStyle = '#111'; c.fillRect(0, 0, this.W, th);
      c.globalAlpha = Math.min(1, this.st/0.6);
      c.textAlign = 'center'; c.textBaseline = 'middle';
      c.fillStyle = BRAND.white; c.font = 'bold 26px sans-serif';
      c.fillText('⚔️   YOU   vs   LOPKIN   🤖', this.W/2, 35);

      const cW = 260, cH = 220, g = 30, lx = this.W/2-cW-g/2, rx = this.W/2+g/2, cy = 60;

      const drawCard = (x, title, color, rows) => {
        c.fillStyle = color + '22'; this._rr(c, x, cy, cW, cH, 12); c.fill();
        c.strokeStyle = color; c.lineWidth = 2; this._rr(c, x, cy, cW, cH, 12); c.stroke();
        c.fillStyle = color; c.font = 'bold 18px sans-serif'; c.textAlign = 'center'; c.fillText(title, x+cW/2, cy+24);
        c.font = '13px sans-serif';
        rows.forEach(([l, v, vc], i) => {
          const yy = cy + 50 + i * 24;
          c.textAlign = 'left'; c.fillStyle = '#aaa'; c.fillText(l, x+16, yy);
          c.textAlign = 'right'; c.fillStyle = vc || BRAND.white; c.fillText(v, x+cW-16, yy);
        });
      };

      drawCard(lx, '👤  YOU', '#e74c3c', [
        ['Time', d.yt+'s'], ['Coverage', d.yc+'%'], ['Score', ''+d.ys],
        ['Obstacles Hit', ''+d.yh], ['Best Combo', 'x'+d.yco],
        ['Mood', d.yc > 70 ? '😤' : '🤬'], ['Sweat Level', '💦💦💦'],
      ]);
      drawCard(rx, '🤖  LOPKIN', BRAND.lime, [
        ['Time', d.lt+'s', BRAND.lime], ['Coverage', d.lc+'%', BRAND.lime], ['Score', '∞', BRAND.lime],
        ['Obstacles Hit', '0', BRAND.lime], ['Best Combo', '∞', BRAND.lime],
        ['Mood', '😎', BRAND.lime], ['Sweat Level', '0', BRAND.lime],
      ]);

      c.textAlign = 'center'; c.fillStyle = BRAND.yellow; c.font = 'bold 14px sans-serif';
      const msg = d.yc < 50
        ? 'You spent '+d.yt+'s and only covered '+d.yc+'%. LOPKIN did '+d.lc+'% — while you napped.'
        : 'Not bad! But '+d.yt+'s of your life vs LOPKIN doing it automatically? Your call.';
      c.fillText(msg, this.W/2, cy+cH+20);
      c.fillStyle = '#666'; c.font = '12px sans-serif';
      c.fillText('Scroll down for options', this.W/2, th-12);
      c.globalAlpha = 1;
    }
  }

  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', () => new MowerGame('mower-game-canvas'));
  else new MowerGame('mower-game-canvas');
})();
